/*global AmCharts, App */

Components.Energy.Manager.ReductorSavingAnalysis = function(container, loadDataLink) {
    /* private */
    var _chart;
    var zoomOut = function() {
        try {
            _chart.zoomOut();
        } catch (e) {
        }
    };
    var prepareDataForChart = function(rawData) {
        var chartData = [];
        for (var index in rawData) {
            var row = rawData[index];
            var record = {};
            record.powerConsumptionActive = Math.round(row.powerConsumptionActive * 100) / 100;
            record.oldConsumption = Math.round(row.oldConsumption * 100) / 100;
            record.saving = Math.round(row.saving * 100) / 100;
            record.savingPercent = row.savingPercent;
            record.date = new Date(row.timestamp * 1000);
            chartData.push(record);
        }
        if (chartData.length == 0) {
            _chart.clear();
        } else {
            _chart.dataSets[0].dataProvider = chartData;
            _chart.validateData();
        }
    };
    var loadData = function() {
        App.Ui.widgetBlock($(_chart.containerDiv));
        $.ajax({
            dataType: "json",
            url: loadDataLink,
            complete: function() {
                App.Ui.widgetBlock($(_chart.containerDiv), "stop");
            },
            success: function(result) {
                if (result === null || result.length === 0) {
                    App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
                } else {
                    if (result.typeOfInterval) {
                        if (result.typeOfInterval === "1-hour") {
                            _chart.categoryAxesSettings.minPeriod = "hh";
                        } else if (result.typeOfInterval === "15-min") {
                            _chart.categoryAxesSettings.minPeriod = "15mm";
                        } else {
                            _chart.categoryAxesSettings.minPeriod = "5mm";
                        }
                    }
                    prepareDataForChart(result.records);
                }
            },
            error: function() {
                App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
            }
        });
    };
    var createChart = function() {
        _chart = new AmCharts.AmStockChart();
        // _chart.colors = App.Ui.getColors();
        _chart.pathToImages = "/dist/amcharts/images/";
        _chart.export = App.Charts.export;
        _chart.dataSets = [
            {
                categoryField: "date",
                fieldMappings: [
                    {
                        fromField: "powerConsumptionActive",
                        toField: "powerConsumptionActive"
                    },
                    {
                        fromField: "oldConsumption",
                        toField: "oldConsumption"
                    },
                    {
                        fromField: "saving",
                        toField: "saving"
                    },
                    {
                        fromField: "savingPercent",
                        toField: "savingPercent"
                    }
                ]
            }
        ];

        var stockPanel = new AmCharts.StockPanel();
        stockPanel.autoMarginOffset = 50;
        stockPanel.recalculateToPercents = "never";
        stockPanel.usePrefixes = true;
        _chart.addPanel(stockPanel);

        var graphA = new AmCharts.StockGraph();
        graphA.id = "sg1";
        graphA.valueField = "powerConsumptionActive";
        graphA.periodValue = "Sum";
        graphA.type = "column";
        graphA.fillAlphas = 1;
        graphA.balloonFunction = function(item) {
            return "Původní spotřeba:<b>" + item.dataContext.oldConsumptionSum + "</b>Wh<br>" +
                "Aktuální spotřeba:<b>" + item.dataContext.powerConsumptionActiveSum + "</b>Wh<br>" +
                // "Úspora: <b>" + item.dataContext.savingSum + "</b>Wh " +
                // "<b>" + item.dataContext.savingPercentAverage.toFixed(2) + "%</b>"
                "";
        };
        graphA.lineColor = "#444444";
        graphA.useDataSetColors = false;
        graphA.valueAxis = "v1";

        var graphB = new AmCharts.StockGraph();
        graphB.id = "sg2";
        graphB.valueField = "oldConsumption";
        graphB.periodValue = "Sum";
        graphB.type = "column";
        graphB.clustered = false;
        graphB.fillAlphas = 1;
        graphB.balloonText = "";
        graphB.lineColor = "#add585";
        graphB.useDataSetColors = false;
        graphB.valueAxis = "v1";

        var valueAxis = new AmCharts.ValueAxis();
        valueAxis.id = "v1";
        valueAxis.position = "left";
        valueAxis.minimum = 0;
        stockPanel.addValueAxis(valueAxis);

        var savingAxis = new AmCharts.ValueAxis();
        savingAxis.id = "v2";
        savingAxis.title = "Procenta";
        savingAxis.position = "right";
        savingAxis.minimum = 0;
        savingAxis.maximum = 60;
        stockPanel.addValueAxis(savingAxis);

        var graphC = new AmCharts.StockGraph();
        graphC.id = "sg2";
        graphC.valueField = "savingPercent";
        graphC.periodValue = "Average";
        graphC.type = "line";
        graphC.lineThickness = 3;
        graphC.fillAlphas = 0;
        graphC.balloonFunction = function(item) {
            return "Úspora: <b>" + item.values.value.toFixed(2) + "%</b>";
        };
        graphC.lineColor = "#e67e22";
        graphC.useDataSetColors = false;
        graphC.valueAxis = "v2";

        stockPanel.addStockGraph(graphB);
        stockPanel.addStockGraph(graphA);
        stockPanel.addStockGraph(graphC);

        var panelsSettings = new AmCharts.PanelsSettings();
        _chart.panelsSettings = panelsSettings;

        var scrollbarSettings = new AmCharts.ChartScrollbarSettings();
        scrollbarSettings.graph = "sg1";
        scrollbarSettings.graphType = "step";
        scrollbarSettings.updateOnReleaseOnly = false;
        _chart.chartScrollbarSettings = scrollbarSettings;

        var cursorSettings = new AmCharts.ChartCursorSettings();
        cursorSettings.categoryBalloonEnabled = true;
        cursorSettings.categoryBalloonDateFormats = [
            {
                period: 'fff',
                format: 'JJ:NN:SS'
            },
            {
                period: 'ss',
                format: 'JJ:NN:SS'
            },
            {
                period: 'mm',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'hh',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'DD',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'WW',
                format: 'DD.MM.YYYY'
            },
            {
                period: 'MM',
                format: 'DD.MM.YYYY'
            },
            {
                period: 'YYYY',
                format: 'MMMM YYYY'
            }
        ];
        cursorSettings.cursorAlpha = 0.05;
        cursorSettings.fullWidth = true;
        cursorSettings.valueBalloonsEnabled = true;
        cursorSettings.valueLineEnabled = false;
        cursorSettings.valueLineBalloonEnabled = false;
        cursorSettings.valueLineAlpha = 0.5;
        _chart.chartCursorSettings = cursorSettings;

        var categoryAxesSettings = new AmCharts.CategoryAxesSettings();
        categoryAxesSettings.groupToPeriods = ["5mm", "15mm", "hh", "6hh", "12hh", "DD", "MM", "YYYY"];
        categoryAxesSettings.minPeriod = "5mm";
        categoryAxesSettings.maxSeries = 150;
        categoryAxesSettings.dateFormats = [
            {
                period: 'fff',
                format: 'JJ:NN:SS'
            },
            {
                period: 'ss',
                format: 'JJ:NN:SS'
            },
            {
                period: 'mm',
                format: 'JJ:NN'
            },
            {
                period: 'hh',
                format: 'JJ:NN'
            },
            {
                period: 'DD',
                format: 'DD.MM.'
            },
            {
                period: 'WW',
                format: 'DD.MM.'
            },
            {
                period: 'MM',
                format: 'DD.MM.'
            },
            {
                period: 'YYYY',
                format: 'MMMM YYYY'
            }
        ];
        _chart.categoryAxesSettings = categoryAxesSettings;

        var valueAxesSettings = new AmCharts.ValueAxesSettings();
        valueAxesSettings.inside = true;
        _chart.valueAxesSettings = valueAxesSettings;

        _chart.addListener("dataUpdated", function() {
            setTimeout(zoomOut, 250);
        });

        _chart.write(container);
        loadData();
    };
    var zoomToHour = function() {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        inactive();
        $("#" + container + "_zoomToHour").addClass("active");
    };
    var zoomToDay = function() {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        inactive();
        $("#" + container + "_zoomToDay").addClass("active");
    };
    var zoomMax = function() {
        zoomOut();
        inactive();
        $("#" + container + "_zoomMax").addClass("active");
    };
    var inactive = function() {
        $("#" + container + "_zoomToHour").removeClass("active");
        $("#" + container + "_zoomToDay").removeClass("active");
        $("#" + container + "_zoomMax").removeClass("active");
    };
    /* public */
    /* contructor */
    createChart();
    $("#" + container + "_zoomToHour").click(zoomToHour);
    $("#" + container + "_zoomToDay").click(zoomToDay);
    $("#" + container + "_zoomMax").click(zoomMax);
};
